// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"94565c69673901caecd8","293":"ffbdc5d449b1fc223847","518":"088ade8395aa29ec723a","779":"8135707d5d1250e2f7a1"}[chunkId] + ".js";
};